

























































import { defineComponent } from '@vue/composition-api';

const TermOfService = defineComponent({
  // setup() {},
});

export default TermOfService;
